/**
 * Sticky Navbar
 * Adds 'is-sticky' class to navbar when scrolling past threshold
 */

export function initStickyNavbar() {
  ScrollTrigger.create({
    start: "top -80",
    end: () => document.body.scrollHeight,
    toggleClass: {
      className: "is-sticky",
      targets: ".navbar2_component",
    },
  });
}
